import { css } from "lit";
export default css `
    :host {
        display: flex;
        position: relative;

    }
    
    .icon {
        max-width: 60px;
        min-width: 55px;
        min-height: 80px;
        position: relative;
    }

    .icon:first-child {
        min-height: 20px;
    }

    .icon > .timeline {
        width: 40px;
        height: 100%;
        border-right: 2px solid var(--bars-and-borders);
        // position: absolute;
    }

    .skinny {
        width: 20px!important;
    }

    .skinny-icon {
        min-width: 40px!important;
      
    }

    .skinny-time {
        min-width: 0!important;
        max-width: 100%!important;
        padding-top: 0!important;
        height: initial;
        min-height: 0!important;
    }
    
    .skinny-timeline-icon {
        top: 5px!important;
    }

    
    .timeline-icon {
        width: 20px;
        height: 20px;
        border-radius: 15px;
        margin: 0 10px;
        text-align: center;
        font-size: 20px;
        position: absolute;
        top: 22px;
    }

    .content {
        width: 100%;
        display: flex;
        flex-grow: 2;
        min-height: 50px;
        padding-top: 10px;
        height: 50px;
    }

    .content-skinny {
        width: 100%!important;
        min-height: 50px!important;
        height: 70px!important;
       
    }
    
    .request-time {
        font-size: 0.7em;
        color: var(--font-color-sub2);
        //position: absolute;
        //left: 50px;
        //top: 15px;
        min-width: 70px;
        max-width: 70px;
        display: block;
        min-height: 50px;
        padding-top: 15px;
        
    }
    
    .timeline-content {
        width: 100%;
    }

    @media only screen and (max-width: 1000px) {
        .icon > .timeline {
            width: 2px;
        }

        .icon {
            width: 15px;

        }

        .request-time {
            display: none;
        }
    }


`;
